<template>
  <div class="window__main">

    <!-- History views -->
    <overlay-scrollbars class="history-contain" :options="{
      scrollbars: { autoHide: 'scroll' },
      overflowBehavior: { x: 'hidden' },
      callbacks: { onScroll: handlerMoreHistory },
    }" ref="scrollbar">
      <!-- History Loading Status -->
      <morebar v-if="toId" :status="pagination.status" @onmore="getHistoryMore"></morebar>
      <!-- Hisstory Content -->
      <div class="historyMenu">
        <div v-if="historyList.length>0" v-for="(item, index) in historyList" :key="index" :id="item.msg_id">
          <div class="text-center muted p-t-10" v-if="timeFormat(item, index)">
            {{ timeFormat(item, index) }}
          </div>

          <!-- system message -->
          <div v-if="item.sender_type=='system_transfer'" style="text-align: center;color: grey">
            <div> <span style="color: red">{{item.content.kefu_name}}</span> 转接过来的消息</div>
            <div>备注：{{item.content.remark}}</div>
          </div>

          <!-- His message -->
          <div class="message-contain message--his"
               v-else-if="item.sender_type=='user' || (item.content.msg_type=='private' && item.content.from != 'kefu_'+user_info.admin_id) || (item.content.msg_type=='group' && item.content.from != 'kefu_'+user_info.admin_id)">
            <!-- type:5客户发的消息-->
            <Bargain @refresh="bargRefresh" v-if="item.content.type == 5" :item="item" :avatar="user_client_info.avatar"></Bargain>
            <!-- type:7系统提示信息-->
            <div v-else-if="item.content.type==7" class="systemInfo">
                <span class="members" v-for="(item,index) in item.content.payload.names">
                  <span v-if="index>0">、</span>{{item}}
                </span>
                <span v-html="textToHtml(item.content.payload.txt)"> </span>
            </div>


            <!-- type3是链接消息-->
            <chat-message v-else-if="item.content.type  == 3" :avatar="item.content.fromData?.avatar"
                          :sender_type="item.sender_type"
                          :nickname="item.content.to.data?.nickname"
                          :msg_type="item.content.msg_type"
                          :role = "group_userInfo[item.content.from]">
              <chat-content slot="his"
                            :data="item"
                            :messageId="item.messageId"
                            :key="item.msg_id"
                            :groupMembers="group_info.userInfo"
                            :type="item.content.type"
                            :content="item.content.payload.name"
                            :imageURL="item.content.payload.thumb"
                            :price="item.content.payload.price"
                            :to_type="item.sender_type"
                            :unread='item.unread'
                            :msg_id='item.msg_id'
                            :thread_id="id"
                            :msg_sn='item.msg_sn'
                            :is_read="item.read"
                            :goods_id="String(item.content.payload?.txt)"
                            :link_type="item.content.payload.link_type"/>
            </chat-message>
            <!-- type:8 卡片消息 -->
            <chat-message
                :role = "group_userInfo[item.content.from]"
                :sender_type="item.sender_type"
                :avatar="item.content.to.data?.avatar?item.content.to.data.avatar:item.content.fromData.avatar"
                :nickname="item.content.to.data?.nickname?item.content.to.data.nickname:item.content.fromData.nickname"
                :msg_type="item.content.msg_type"

                v-else-if="item.content.type == 8"
            >
              <chat-content slot="his"
                            :messageId="item.messageId"
                            :data="item"
                            :key="item.msg_id"
                            :type="item.content.type"
                            :content="item.content.payload?.txt"
                            :imageURL="imageURL"
                            :unread='item.unread'
                            :groupMembers="group_info.userInfo"
                            :msg_id='item.msg_id'
                            :thread_id="id"
                            :msg_sn='item.msg_sn'
                            :to_type="item.sender_id != user_info.admin_id?'user':'my'"
                            :is_read="item.read"
                            :goods_id="String(item.content.payload?.txt)"
                            :images_list="imageList"/>
            </chat-message>
            <!-- 普通消息 -->
            <chat-message
                          :role = "group_userInfo[item.content.from]"
                          :sender_type="item.sender_type"
                          :avatar="item.content.to.data?.avatar?item.content.to.data.avatar:item.content.fromData.avatar"
                          :nickname="item.content.to.data?.nickname?item.content.to.data.nickname:item.content.fromData.nickname"
                          :msg_type="item.content.msg_type"
                          v-else>
              <chat-content slot="his"
                            :messageId="item.messageId"
                            :data="item"
                            :key="item.msg_id"
                            :type="item.content.type"
                            :content="item.content.payload?.txt"
                            :imageURL="imageURL"
                            :unread='item.unread'
                            :groupMembers="group_info.userInfo"
                            :msg_id='item.msg_id'
                            :thread_id="id"
                            :msg_sn='item.msg_sn'
                            :to_type="item.sender_id != user_info.admin_id?'user':'my'"
                            :is_read="item.read"
                            :goods_id="String(item.content.payload?.txt)"
                            :images_list="imageList"/>
            </chat-message>


          </div>

          <!-- Mine message -->
          <div class="message-contain message--my" v-else>
            <!-- type:6,系统客服消息 -->
            <System v-if="item.content.type == 6 || item.content.type == 5" :item="item" :avatar="user_info.avatar"></System>
            <!-- type:7系统提示信息-->
            <div v-else-if="item.content.type==7" class="systemInfo">
              <span class="members" v-for="(item,index) in item.content.payload.names">
                  <span v-if="index>0">、</span>{{item}}
              </span>
              <span v-html="textToHtml(item.content.payload.txt)"></span>
            </div>
            <chat-message v-else-if="item.content.type  == 3" :sender_type="item.sender_type"
                          :msg_type="item.content.msg_type"
                          :role="group_userInfo[item.content.from]"
                          :avatar="item.content.to.data?.avatar?item.content.to.data.avatar:item.content.fromData.avatar"
                          :nickname="item.content.to.data?.nickname?item.content.to.data.nickname:item.content.fromData.nickname"
                          :type = "item.content.type"

            >
              <!-- :is_read="item.is_read" -->
              <chat-content
                  :messageId="item.messageId"
                  :data="item"
                  :key="item.msg_id"
                  slot="my"
                  :type="item.content.type"
                  :content="item.content.payload.name"
                  :imageURL="item.content.payload.thumb"
                  :price="item.content.payload.price"
                  :to_type="item.sender_type"
                  :groupMembers="group_info.userInfo"
                  :is_read="item.read"
                  :goods_id="String(item.content.payload?.txt)"
                  :link_type="item.content.payload.link_type"
                  :unread='item.unread' :msg_id='item.msg_id' :thread_id="id" :msg_sn='item.msg_sn'
              />
            </chat-message>
            <!--                          :avatar="item.content.to.data?.avatar" -->
            <!--                          :nickname="item.content.to.data?.nickname"-->

            <chat-message
                          v-else
                          :sender_type="item.sender_type"
                          :avatar="item.content.to.data?.avatar?item.content.to.data.avatar:item.content.fromData.avatar"
                          :nickname="item.content.to.data?.nickname?item.content.to.data.nickname:item.content.fromData.nickname"
                          :msg_type="item.content.msg_type"
                          :role="group_userInfo[item.content.from]"
                          :type = "item.content.type"

            >
              <!-- :is_read="item.is_read" -->
              <chat-content :key="item.msg_id" slot="my"
                            :groupMembers="group_info.userInfo"
                            :messageId="item.messageId"
                            :type="item.content.type"
                            :content="item.content.payload?.txt"
                            :imageURL="imageURL"
                            :images_list="imageList"
                            :unread='item.unread'
                            :msg_id='item.msg_id'
                            :thread_id="id"
                            :msg_sn='item.msg_sn'
                            :to_type="item.sender_type"
                            :is_read="item.read"
                            :data="item"
              />
            </chat-message>
          </div>
        </div>
        <div id="bottom"> </div>

      </div>
      <!-- No Session -->
      <!--      <template v-if="!toId&&!thread_id">-->
      <!--        <div class="emptyMenu">-->
      <!--           <img src="@/assets/images/bg_chat.png">-->
      <!--        </div>-->
      <!--      </template>-->
    </overlay-scrollbars>

    <!-- Editor -->
    <div class="editor-contain">
      <!-- Widget -->
      <div class="editor__widget">
        <div class="editor__my">
          <!-- @用户 -->
          <el-popover placement="top" width="200" trigger="manual" v-model="atUsers" :disabled="!toId" v-if="chatType=='group'">
            <div class="users">
              <div v-for="(user,index) in at_user_lists"  :class="index==at_user_index?'userinfo selected':'userinfo'"
                   @keydown.enter = 'atUser(user.nickname)'
                   @click="atUser(user.nickname,true)">
                <div class="el-avatar">
                  <img :src="'https://img.taohaozhijia.cn/'+user.avatar" :alt="user.nickname">
                </div>
                <div class="nickname">
                  {{user.nickname}}
                </div>
              </div>
              按↕键切换所选用户
            </div>
            <el-tooltip slot="reference" class="item" effect="dark" content="@用户" placement="bottom">
              <div class="flex" style="margin-top: -2px">
                <i class="iconfont icon-at" @click="atUsers=!ban?!atUsers:false;at_user_index=-1"
                   tabindex="0"
                   @keydown.up="upKeyDown"
                   @keydown.down="downKeyDown"
                ></i>
              </div>
            </el-tooltip>
          </el-popover>
          <!-- 发送表情 -->
          <el-popover placement="top" title width="240" trigger="click" :disabled="!toId">
            <div class="flex flex-wrap" style="gap: 4px">
            <span :class="`em ${item} `" v-for="(item, index) in emoji" :key="index" @click="sendEmoji(item)"
                  style="font-size: 20px"></span>
            </div>
            <el-tooltip slot="reference" class="item" effect="dark" content="表情" placement="bottom">
              <div class="flex" style="margin-top: -2px">
                <i class="iconfont icon-weixiao" ></i>
              </div>
            </el-tooltip>
          </el-popover>

          <!-- 选择图片 -->
          <el-tooltip slot="reference" class="item" effect="dark" content="图片" placement="bottom">
            <el-upload :action="uploadURL"
                       accept=".jpg, .jpeg, .png, .JPG, .JPEG"
                       :headers="{ token: $store.getters.token, version }"
                       :show-file-list="true"
                       ref="upload"
                       :file-list="files"
                       :auto-upload="true"
                       :before-upload="beforeImageUpload"
                       :on-success="sendMessageImage"
                       :disabled="!toId">
              <i class="widget-item el-icon-picture-outline-round"></i>
            </el-upload>
          </el-tooltip>

          <!-- 快捷回复 -->
<!--          <el-tooltip slot="reference" class="item" effect="dark" content="快捷回复" placement="bottom">-->
<!--            <i class="widget-item el-icon-chat-line-round m-b-4" @click="isShowReply"></i>-->
<!--          </el-tooltip>-->

          <!-- 切换客服 -->
          <el-tooltip slot="reference" class="item" effect="dark" :content="chatType=='private'?'转线':'添加群成员'" placement="bottom">
            <i class="widget-item" :class="chatType=='private'?'el-icon-refresh':'el-icon-circle-plus-outline'" @click="isShowChangeKefu"></i>
          </el-tooltip>

          <!-- 发放红包 -->
          <el-tooltip slot="reference" class="item" effect="dark" content="发放优惠券" placement="bottom">
            <i class="widget-item iconfont icon-youhuiquan"  @click="isShowCoupon=true"></i>
          </el-tooltip>

          <!-- 商品推荐 -->
          <el-popover
            trigger="manual"
            v-model="tuijianPopVisible"
            :disabled="!toId"
            placement="top"
          >
            <el-input size="mini" v-model="tuijian_goods_id" placeholder="请输入推荐商品编号ID"></el-input>
            <div class="tuijian_btns">
              <el-button @click="tuijianPopVisible = false;tuijianVisible=false;" size="mini">取消</el-button>
              <el-button @click="tuijian" size="mini" type="danger"> 推荐商品 </el-button>
            </div>
            <template slot="reference">
              <el-tooltip @close="tuijianVisible = false;" slot="reference" class="item" effect="dark" content="商品推荐" placement="bottom">
                <i class="iconfont icon-tj"  @click="tuijianPopVisible = true"></i>
              </el-tooltip>
            </template>
          </el-popover>

          <!-- 全员禁言 -->
          <el-tooltip slot="reference" class="item" effect="dark" :content="ban?'解除禁言':'全员禁言'" placement="bottom">
            <i class="iconfont icon-jinyan" :class="ban?'ban':''" @click="banChat"></i>
          </el-tooltip>

        </div>



        <div class="right-fn">
          <!-- 电话提醒 -->
          <el-tooltip slot="reference" class="item" effect="dark" content="电话提醒" placement="bottom">
            <i class="widget-item el-icon-phone-outline" @click="callTipBox=true"></i>
          </el-tooltip>

          <!-- 短信提醒 -->
          <el-tooltip slot="reference" class="item" effect="dark" content="短信提醒" placement="bottom">
            <i class="widget-item el-icon-message" @click="smsTipBox=true"></i>
          </el-tooltip>
        </div>

      </div>

      <!-- Editor -->
      <div
          @input="handleInput"
          id="sendDiv"
          class="editor__textarea sendDiv"
          :class="ban?'disabled':''"
          :contenteditable="!ban"
          ref="editor"
          @paste="handlePaste"
          @drop.prevent="handleDrop"
          @dragover="handleDragOver"
          @dragover.prevent
          @keydown.enter.prevent
          @keyup.enter="onSendMsg"
          @keydown.up="upKeyDown"
          @keydown.down="downKeyDown"
      ></div>

      <!-- Footer -->
      <div class="editor__action">
        <el-button type="danger" size="small" @click="cancelConfirm" v-if="chatType === 'group'">
          终止交易
        </el-button>
        <el-button type="warning" size="small" @click="resendBindConfirm" v-if="group_status===4 && chatType === 'group'">
          重新发起换绑确认
        </el-button>
        <el-button type="primary" size="small"
                   :disabled="!toId || ban"
                   :loading="false"
                   @click="onSendMsg">发送</el-button>

      </div>
      <div class="scrolling-container">
        <div class="scrolling-text">
         文字聊天、语音/隐私号沟通中，严禁与消费者交换手机号、座机号，严禁添加消费者微信/QQ/支付宝等账号，否则构成诱导第三方违规，需缴纳5000保证金且被采取其他处理措施!&nbsp;
          &nbsp;&nbsp;&nbsp;
        </div>
        <div class="scrolling-text" aria-hidden="true">
          文字聊天、语音/隐私号沟通中，严禁与消费者交换手机号、座机号，严禁添加消费者微信/QQ/支付宝等账号，否则构成诱导第三方违规，需缴纳5000保证金且被采取其他处理措施!&nbsp;
          &nbsp;&nbsp;&nbsp;
        </div>
      </div>
    </div>

    <!-- 快捷回复 -->
<!--    <quick-reply v-model="showReply" @select="selectReply"/>-->

    <!-- 商品推荐 -->
    <tuijian-goods v-model="tuijianVisible" @close="tuijianVisible=false;tuijian_goods_id=null;tuijianPopVisible=false;" :goods-id="tuijian_goods_id" :to-id="toId" :type="chatType"></tuijian-goods>

    <!--转接在线客服 -->
    <my-change-kefu v-model="showChangeKefu" @changeKefu="changeKefuFn"/>

    <!-- 发放优惠券 -->
    <coupon-list v-if="isShowCoupon" @close="isShowCoupon=false" :chat_type="chatType" :thread_id="thread_id" :to_id="toId" :users="at_user_lists" ></coupon-list>

    <el-dialog
        title="短信提醒"
        :visible.sync="smsTipBox"
        top="30vh"
        width="20%">
      <div class="msg_tip_btns" v-if="chatType=='group'">
        <div>
          <el-button type="success" @click="smsTip('seller')">提醒卖家处理</el-button>
        </div>
        <div>
          <el-button type="primary" @click="smsTip('buyer')">提醒买家处理</el-button>
        </div>
      </div>

      <div class="msg_tip_btns" v-else>
        <el-button type="primary" @click="sendMsg_mobile">提醒买家未读</el-button>
      </div>
    </el-dialog>

    <el-dialog
        title="电话提醒"
        :visible.sync="callTipBox"
        top="30vh"
        width="20%">
      <div class="msg_tip_btns" v-if="chatType=='group'">
        <div>
          <el-button type="success" @click="callTip('seller')">提醒卖家处理</el-button>
        </div>
        <div>
          <el-button type="primary" @click="callTip('buyer')">提醒买家处理</el-button>
        </div>
      </div>

      <div class="msg_tip_btns" v-else>
        <div>
          <el-button type="primary" @click="callTip('buyer_unread')">提醒买家未读</el-button>
        </div>
        <div>
          <el-button type="success" @click="callTip('buyer_bargain')">提醒买家议价通过</el-button>
        </div>
      </div>
    </el-dialog>
  </div>




</template>

<script>
import {apiServiceSendOrderMsg, recallMessageFn, transferKefu} from '@/api/app'
import ChatMessage from "@/components/ChatMessage";
import Bargain from "@/components/ChatMessage/bargain.vue";
import System from "@/components/ChatMessage/system.vue";
import QuickReply from "./QuickReply";
import {
    apiChatHistory,
    apiUploadFile,
    apiServiceList,
    apiaddRecord,
    chatList,
    resendBindProgress,
    sendChat,
    getKefu,
    Read,
    msgTip,
    callTip,
    smsTip,
    banGroup,
    debanGroup,
    cancelDeal
} from "@/api/app";
import {E_Msg, E_MsgEvent, E_Load} from "@/utils/enum";
import Morebar from "@/components/Morebar";
import ChatContent from "@/components/ChatContent";
import config from "@/config";
import {mapGetters, mapActions} from "vuex";
import emojiArr from "@/utils/emojiArr.js";
import {debounce} from "@/utils/util.js";
import {timeFormatChat} from "@/utils/date";
// import notice from "@/assets/notice.mp3";
import MyChangeKefu from "./MyChangeKefu";

let is_add = false;
import Event from "@/utils/event";
import request from "@/plugins/axios";
import CouponList from "../../../components/Coupon/lists.vue";
import TuijianGoods from "../../../components/Goods/index.vue";
import {confirmMessage} from "../../../api/app";

export default {
  name: "TheWindowMain",
  components: {
    TuijianGoods,
    CouponList,
    MyChangeKefu,
    ChatMessage,
    QuickReply,
    Morebar,
    Bargain,
    System,
    ChatContent,
  },

  props: {
    avatar: {
      type: String,
      default: ''
    },
    toId: {
      type: [String, Number],
      default: "",
    },

    fromId: {
      type: [String, Number],
      default: "",
    },
    chatType: {
      type: [String, Number],
      default: "",
    },
    thread_id: {
      type: [String, Number],
      default: 0,
    }
  },

  emits: ['changeKefuRefresh'],

  inject: ["sendMessage", "send"],

  data() {
    return {
      files: [],
      tuijianVisible:false,
      tuijianPopVisible:false,
      tuijian_goods_id:null,
      isComposing:false,
      atUsers:false,
      smsTipBox:false,
      callTipBox:false,
      group_status:1,
      ban:false,
      editorContent: "",// 编辑内容
      historyList: [],// 历史消息列表
      showReply: false,// 显示快捷回复
      showChangeKefu: false,//显示转接在线客服
      /* 分页器 */
      pagination: {
        size: 15,
        page: 1,
        status: E_Load["NORMAL"],
        total: 0,
        more: true,
      },
      /* 滚动条 */
      scrollbar: null,
      uploadURL: config.baseURL + "/tenantapi/upload/image",
      uploadURL_video: config.baseURL + "/tenantapi/upload/video",
      version: config.version,
      kefuLists: [],
      at_user_lists:[],
      user_info: {},
      showEmoji: false, // 表情输入框
      emoji: [],
      id: 0,
      cur:0,
      handlerMoreHistory: null,
      readBack: false,
      imageList: [],
      group_info: {},//群组信息
      user_client_info: {},//用户信息
      group_userInfo:{},
      tmpUsers: [],
      ScrollToBottom:false,
      at_user_index:0,
      caretPosition:0,
      isShowCoupon:false,
      //富文本
      editorOption: {
        placeholder: '请输入内容',
        theme: 'snow',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline'],
            [{'header': 1}, {'header': 2}],
            [{'list': 'ordered'}, {'list': 'bullet'}],
            ['image', 'code-block']
          ]
        }
      },
    };
  },

  watch: {
    toId: {
      handler(id) {
        this.changeSession(id);
      },
      immediate: true,
    },
    thread_id(id) {
      this.ban = false;
      this.id = id;
      this.pagination.page = 1;
      this.pagination.status = E_Load["NORMAL"];
      this.upread();
    },
  },

  computed: {
    timeFormat() {
      return (item, index) => {
        if (!item?.create_time) return "";
        if(this.historyList[index - 1]==undefined) return "";
        let timeFmt = timeFormatChat(item.create_time);
        let cur_time = new Date(item.create_time).getTime();
        let next_time = new Date(this.historyList[index - 1].create_time).getTime();
        let dis_time = (cur_time - next_time)/1000;
        if (index && dis_time <= 300 && !item.show_time) {
          timeFmt = "";
        }
        return timeFmt;
      };
    },
    imageURL() {
      return this.$store.getters.baseUrl;
    }
  },

  async created() {
    this.$event.$on("connected", this.init);
    this.$event.$on("disconnected", this.disconnected);
    this.$event.$on("loadedImg",()=>{
      if(this.ScrollToBottom){
        this.ScrollToBottom = false;
        this.scrollTopFn();
      }
    })
    this.$event.$on("group_info_load", (datas) => {
      const index = datas.users.indexOf('kefu_' + this.user_info.admin_id);
      if (index >= 0) datas.users.splice(index, 1);
      this.group_info = datas;
      this.group_userInfo = {};
      let map = {1:'user_',2:'kefu_'};
      this.at_user_lists = [];
      this.at_user_index = -1;
      this.group_info.userInfo.map((item)=>{
        this.group_userInfo[map[item.user_type]+item.user_id] = item.role;
        item.user['user_id'] = item.user_id;
        item.user['user_role'] = item.role;
        this.at_user_lists.push(item.user);
      });
      this.group_status = datas.status;
      if(datas.ban) this.ban=true;
    });

    this.$event.$on("user_info_load", (datas) => {
      this.user_client_info = datas;
    });


    //这里第二次获取客服信息
    this.user_info = await getKefu()
    this.emoji = emojiArr;
  },

  mounted() {
    this.scrollbar = this.$refs["scrollbar"].osInstance();
    this.$event.$on('quick-reply-select',this.selectReply);
  },
  beforeDestroy() {
      this.$event.$off("connected", this.init);
  },
  methods: {
    tuijian(){
      this.tuijianVisible = true;
      this.tuijianPopVisible = false;
      console.log("显示推荐");
    },
    async smsTip(type='user'){
      if(this.ban) return;
      if(this.toId==null) return;
      await smsTip({'type':type,'group_id':this.toId});
      this.$message("发送成功");
    },
    async callTip(type='user'){
        if(this.ban) return;
        if(this.toId==null) return;
        if(type=='buyer'||type=='seller'){
          await callTip({'type':type,'group_id':this.toId});
        }else{
          await callTip({'type':type,'user_id':this.toId});
        }
        this.$message("拨打成功");
    },
    init() {
        this.$net.socket.on("message",this.sreceiveMessage.bind(this));
        this.$net.socket.on("read",this.onMessageRead.bind(this));//已读回执
        this.$net.socket.on("recall",this.onMessageRecalled.bind(this));//撤回回执
    },
    disconnected(){
        this.historyList = [];
    },
    //收到用户信息已读回执
    onMessageRead(message) {
      this.readBack = true;
      let user_id = Number(message.from.replace("user_", ""));
      if (this.$timer.msgTipTimer[user_id]) {
        //用户已收到消息,无需发送短信提醒
        clearTimeout(this.$timer.msgTipTimer[user_id]);
      }
      if (message.payload.thread_id != this.id) return;
    },
    upread() {
      if (!this.toId) return;
      Read({
        user_id: this.chatType == 'private' ? this.toId : null,
        thread_id: this.id,
        type: this.chatType
      });
    },
    async cancelConfirm(){
      const r = await cancelDeal({group_id:this.toId});
      if(r['success']){
        this.$message(r['msg']);
        this.group_status = 4;//取消交易并禁言
        this.ban = true;
      }
    },
    async resendBindConfirm(){
      const r = await resendBindProgress({group_id:this.toId});
      if(r['success']){
         this.$message(r['msg']);
          this.group_status = 1;
          this.ban = false;
      }
    },
    getRecord() {
      chatList({
        url: `page_no=${this.pagination.page}&page_size=${this.pagination.size}`,
        thread_id: this.thread_id
      }).then((res1) => {
        this.scrollTopFn();
        res1.lists.forEach(item => {
          this.historyList.unshift(item);
        });
        is_add = true;
        setTimeout(() => {
          if (this.historyList.length) {
            // const topEl = document.getElementById(this.historyList[this.historyList.length - 1].msg_id);
            const topEl = document.getElementById(this.historyList[this.historyList.length - 1].msg_id);
            this.scrollbar.scroll(topEl);
          }
        }, 100)
      }).catch((err1) => {
      })
    },

    // 出顶加载更多
    async loadHistoryMore(e) {
      const {scrollTop} = e.target;
      if (scrollTop < 20) {
        let id = this.historyList[0] ? this.historyList[0].msg_id : "";
        const topEl = document.getElementById(id);
        this.pagination.page++;
        this.historyList[0] && (this.historyList[0].show_time = true);
        await this.getChatHistory(this.toId, this.chatType);
      }
    },

    // 打开快捷回复
    isShowReply() {
      if (this.toId) {
        this.showReply = true;
      }
    },

    //打开转接在线客服
    isShowChangeKefu() {
      if (this.toId) {
        this.showChangeKefu = true;
      }
    },

    // 发送表情
    sendEmoji(item) {
      if(this.ban) return;
      this.ring = true;
      this.$refs.editor.innerHTML += `[${item}]`
      this.editorContent += `[${item}]`;
    },

    //点击发送消息
    async onSendMsg(event) {
      if(this.atUsers){
        this.atUser(this.at_user_lists[this.at_user_index].nickname);
        return;
      }
      if(this.ban) return;
      if (!this.toId) {
        this.$notify.error({
          title: '错误',
          message: '请先选择用户'
        });
        return
      }
      const div = document.getElementById('sendDiv')

      // 提取文字和图片，按顺序存储
      const contentArray = this.extractContent(div);
      // 逐个发送：按顺序发送文字和图片
      for (const content of contentArray) {
        if (content.type === 'text') {
          await this.sendTextMessage(content.value);
        } else if (content.type === 'image') {
          await this.sendImageMessage(content.value);
        } else if (content.type === 'video') {
          await this.sendVideoMessage(content.value);
        }
      }

      //清理数据
      div.innerHTML = ''
      if (event.shiftKey) return;
    },

    async onSendMessage(txt, type) {
        if(this.ban) return;
        if (!this.toId) return this.$message.error("请选择聊天用户");
        if (txt.trim() === "") return;
        let users = [];
        let pre = "user_"
        if (this.chatType === 'group') {
            users = this.group_info.users.map(users => users);
            this.tmpUsers = users;//临时用户列表
            pre = "group_";
        }
        let msgData = this.$net.buildMsg(pre+this.toId,txt,this.chatType,type,this.id);
        this.$net.sendMsg(msgData);
        this.editorContent = "";
        if (type === 2) {
            this.imageList.push(txt);
        }
        await this.$nextTick();
        this.scrollTopFn();
    },

    async handlePaste(e) {
      // 先判断是否有接收人
      if (!this.toId) return;
      // 防止浏览器默认的粘贴行为
      const clipboardItems = e.clipboardData.items;
      const divOrigin = this.$refs.editor; // 获取 contenteditable 的 div
      let textContent = '';
      let images = [];

      // 解析剪贴板的内容
      for (let i = 0; i < clipboardItems.length; i++) {
        const item = clipboardItems[i];

        // 如果是图片，处理图片
        if (item.type.indexOf('image') !== -1) {
          e.preventDefault();  // 阻止默认粘贴行为
          const file = item.getAsFile();

          const imageUrlTemp = URL.createObjectURL(file)
          const imgElement = document.createElement('img');
          imgElement.src = imageUrlTemp;
          const imageUrl = await this.uploadImage(file);
          //插入到 contenteditable 的 div 中
          imgElement.src = imageUrl;
          divOrigin.appendChild(imgElement); // 将图片插入到 div 中
        }

        // 如果是视频，处理视频
        if (item.type.indexOf('video') !== -1) {
          e.preventDefault();  // 阻止默认粘贴行为
          const file = item.getAsFile();
          const videoUrlTemp = URL.createObjectURL(file);
          const videoElement = document.createElement('video');
          videoElement.src = videoUrlTemp;
          videoElement.controls = true; // 添加控制条
          videoElement.width = 400; // 固定宽度
          videoElement.height = 300; // 固定高度
          divOrigin.appendChild(videoElement); // 将视频插入到 div 中

          const videoUrl = await this.uploadVideo(file); // 你可以创建一个上传视频的 API
          videoElement.src = videoUrl;
        }

      }
    },

    onRead(datas) {
      if (datas.thread_id == this.id) {
        let index = this.tmpUsers.indexOf(datas.from_id);
        if (index >= 0) {
          this.tmpUsers.splice(index, 1);
        }
      }
    },

    getCaretPosition() {
      const selection = window.getSelection();
      const range = selection.getRangeAt(0);
      const cursorPos = range.startOffset;
      return cursorPos;
    },
    handleCompositionEnd() {
        this.isComposing = false
        this.caretPosition = this.getCaretPosition(this.$refs.editor)
      },
  //@用户
    atUser(nickname,end=false){
      this.atUsers = false;
      if(this.$refs.editor.innerHTML.length==0||this.$refs.editor.innerHTML=='<br>') {
        this.$refs.editor.innerHTML='';
      }
      let cur = this.cur;
      let cur_content = this.$refs.editor.innerHTML.at(cur);
      if(cur_content=='@') {
        const content = this.$refs.editor.innerHTML.slice(0, cur) + this.$refs.editor.innerHTML.slice(cur + 1, this.editorContent.length);
        this.$refs.editor.innerHTML = content;
      }
      nickname = ' @'+nickname+' ';
      if(end==false){
        this.$refs.editor.innerHTML = this.$refs.editor.innerHTML.slice(0,cur)+nickname+this.$refs.editor.innerHTML.slice(cur,this.editorContent.length);
      }else{
        this.$refs.editor.innerHTML += nickname;
      }
      const range = document.createRange();
      const selection = window.getSelection();
      range.selectNodeContents(this.$refs.editor);
      range.collapse(false);
      selection.removeAllRanges();
      selection.addRange(range);
    },

    //发送图片消息
    sendMessageImage({code, data, msg}) {
      if (code !== 1) return this.$message.error(msg);
      this.onSendMessage(data.uri, 2);
    },

    //发到消息
    receiveMessage(message) {
      if (message.to_id == this.toId || message.from_id == this.toId) {
        this.historyList.push(message);
      }
      const {max, position} = this.scrollbar.scroll();
      if (max.y - position.y <= 50) {
        this.$nextTick(() => {
          this.scrollbar.scroll("100%");
        });
      }
    },

    //收到消息
    async sreceiveMessage(message) {
      console.log("收到消息",message);
      if(message.payload.thread_id != this.thread_id) return ;
      this.ScrollToBottom = true;
      if(message.payload.update_group_status){
        if(message.payload.ban) {
          this.ban  = true;
          this.$event.$emit('group_info_update');
        }else{
          this.group_status = message.payload.status;
          this.ban  = false;
          this.$event.$emit('group_info_update');
        }
      }
      let msgData = {
        from: message.from,
        to: message.to,
        sender_type: "user",
        read: 1,
        msg_sn: message.timestamp,
        msg_id: message.messageId,
        messageId: message.messageId,
        content: {
          from:message.from,
          msg_type: message.msg_type,
          type: message.type,
          read:message.content.read,
          to: {
            data: message.fromData,
            type: this.chatType
          },
          payload: message.payload
        },
      };
      if (message.from === "kefu_" + this.$net.userInfo.user_id) {
          msgData.sender_type = "kefu";
          msgData.read = 0;
          //群组消息剔除已读成员
          if(message.msg_type === 'group') {
            this.tmpUsers = this.group_info.users.map(users => users);//临时用户列表
            let index  = this.tmpUsers.indexOf(message.from);
            if(index >= 0) this.tmpUsers.splice(index, 1);
            msgData.unread =  this.tmpUsers;
          }
          //标记已读
          let data = {
            'from':message.from,
            'to':message.to,
            'messageId':message.messageId,
            'msg_type':message.msg_type
          }
          this.$net.upRead(data);//消息端标记已读
          this.upread();//服务端标记已读
      }else{
          //如果是图片添加到图片列表中
          if(message.type == 2){
            this.imageList.push(message.payload.txt);
          }else if(message.type == 8){
            if(message.payload.images) this.imageList=[...this.imageList,...message.payload.images];
          }

          if(message.msg_type === 'group') {
            this.tmpUsers = this.group_info.users.map(users => users);//临时用户列表
            let index  = this.tmpUsers.indexOf(message.from);
            if(index >= 0) this.tmpUsers.splice(index, 1);
            msgData.unread =  this.tmpUsers;
          }
          //标记已读
          let datas = {
            'from':message.from,
            'to':message.to,
            'messageId':message.messageId,
            'msg_type':message.msg_type
          }
          this.$net.upRead(datas);//消息端标记已读
          this.upread();//己端标记已读
      }
      this.historyList.push(msgData);
      this.scrollTopFn();
    },

    scrollTopFn() {
      setTimeout(() => {
        if (this.historyList.length) {
          const topEl = document.getElementById("bottom");
          this.scrollbar.scroll(topEl);
        }
      },100);
    },

    //获取历史消息
    getChatHistory(id, chattype) {
      if (!id) return;
      return new Promise((resolve, reject) => {
        const {size, page, status} = this.pagination;
        if (status == E_Load["EMPTY"]) return;
        this.pagination.status = E_Load["LOAD"];
        chatList({
          thread_id: this.thread_id,
          type: chattype,
          url: `page_no=${page}&page_size=${size}`
        }).then((data) => {
          let msgs = [];
          data.lists.forEach((item) => {
            if (item.content.type == '2') {
              this.imageList.push(item.content.payload.txt);
            }else if(item.content.type == '8'){
              if(item.content.payload.images) this.imageList=[...this.imageList,...item.content.payload.images];
            }
            //未读消息标记已读,发送已读回执
            if(!item.content?.read?.includes('kefu_'+this.$net.userInfo.user_id)){
                let datas = {
                  'from':item.content.from,
                  'to':item.content.to,
                  'messageId':item.messageId,
                  'msg_type':item.content.msg_type,
                }
                //发送已读回执
                this.$net.upRead(datas);
            }
            item.msg_id = item.messageId!=null?item.messageId:item.msg_id;
            msgs.unshift(item);
          });
          this.historyList = [...msgs, ...this.historyList];
          this.pagination.total = data.count;
          this.pagination.status = data.lists.length < size ? E_Load["EMPTY"] : E_Load["NORMAL"];
          resolve(data);
        }).catch((err) => {
          this.pagination.status = E_Load["ERROR"];
          this.scrollTopFn();
          reject(err);
        });

      });
    },

    //获取更多记录信息
    async getHistoryMore() {
      const topEl = document.getElementById(this.historyList[0].msg_id);
      this.historyList[0].show_time = true;
      this.pagination.page++;
      await this.getChatHistory(this.toId, this.chatType);
    },

    // 选择快捷回复
    selectReply(msg) {
      const div = document.getElementById('sendDiv');
      div.innerHTML = msg;
    },
    upKeyDown() {
      event.preventDefault();
      this.at_user_index = this.at_user_index-1>-1?--this.at_user_index:this.at_user_lists.length-1;
    },
    downKeyDown(){
      event.preventDefault();
      this.at_user_index = this.at_user_index+1<=this.at_user_lists.length-1?++this.at_user_index:0;
    },
    async changeSession(id) {
      this.pagination.size = 15;
      this.pagination.page = 1;
      this.pagination.total = 0;
      this.pagination.more = true;
      this.pagination.status = E_Load["NORMAL"];
      this.historyList = [];
      this.imageList = [];
      id && (await this.getChatHistory(id, this.chatType));
      this.$nextTick(() => {
        this.ScrollToBottom = true;
        this.scrollTopFn();
      });
    },

    //上传图片之前
    beforeImageUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      // const isPNG = file.type === 'image/png';
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5MB!");
      }
      return isLt5M;
    },

    transfer(item) {
      this.send("transfer", {
        user_id: this.toId, // 用户id
        kefu_id: item.id, // 新客服id
      });
      this.showKefu = false;
    },

    // 将剪贴板的 HTML 内容分离成文字和图片
    extractContent(div) {
      const contentArray = [];
      let textBuffer = ''; // 用于累积连续文本

      const flushText = () => {
        if (textBuffer.trim() !== '') {
          contentArray.push({type: 'text', value: textBuffer});
        }
        textBuffer = '';
      };

      const traverse = (node) => {
        if (node.nodeName === 'IMG') {
          flushText();
          contentArray.push({type: 'image', value: node.src});
        } else if (node.nodeType === Node.TEXT_NODE) {
          textBuffer += node.textContent; // 不去掉换行
        } else if (
            node.nodeName === 'SPAN' ||
            node.nodeName === 'FONT' ||
            node.nodeName === 'DIV' ||
            node.nodeName === 'P'
        ) {
          // 如果是块元素，递归处理后加换行
          node.childNodes.forEach(traverse);

          // 如果是段落或 DIV，可能表示换行
          if (node.nodeName === 'P') {
            textBuffer += '\n';
          }
        } else {
          // 递归遍历其他节点
          node.childNodes?.forEach(traverse);
        }
      };

      div.childNodes.forEach(traverse);
      flushText(); // 处理剩余的文本

      return contentArray;
    },

    // 发送文字消息
    sendTextMessage(text) {
      this.onSendMessage(text, 1);
    },

    // 发送图片消息
    async sendImageMessage(imageUrl) {
      this.onSendMessage(imageUrl, 2);
    },

    async sendVideoMessage(videoUrl) {
      this.onSendMessage(videoUrl, 2);
    },

    // 上传图片到服务器
    async uploadImage(file) {
      const formData = new FormData();
      formData.append('file', file); // 将文件附加到 FormData 中

      try {
        const response = await axios.post(this.uploadURL, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            token: this.$store.getters.token,
            version: this.version,
          }
        });
        // 假设服务器返回图片的 URL
        const imageUrl = response.uri;
        return imageUrl; // 返回图片的 URL
      } catch (error) {
        console.error('图片上传失败', error);
        throw error;
      }
    },

    //上传视频到服务器
    async uploadVideo(file) {
      const formData = new FormData();
      formData.append('file', file); // 将文件附加到 FormData 中

      try {
        const response = await axios.post(this.uploadURL_video, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            token: this.$store.getters.token,
            version: this.version,
          }
        });
        // 假设服务器返回图片的 URL
        const videoUrl = response.uri;
        return videoUrl; // 返回图片的 URL
      } catch (error) {
        console.error('图片上传失败', error);
        throw error;
      }
    },
    handleInput(event) {

      if(this.$refs.editor.innerHTML=='<br>') {
        this.$refs.editor.innerHTML = null;
      }
      this.editorContent = this.$refs.editor.innerHTML;
      if(event.data == '@'){
        if(this.chatType=='group'){
          this.at_user_index = -1;
          this.atUsers=true;
        }
      }else{
        this.atUsers=false;
      }
      this.cur = this.getCaretPosition() - 1;
    },

    async handleDrop(e) {
      e.preventDefault(); // 阻止默认的处理方式（例如打开文件）

      // 获取拖拽的文件
      const files = e.dataTransfer.files;

      if (files.length > 0) {
        const divOrigin = this.$refs.editor; // 获取 contenteditable 的 div

        // 处理文件
        for (let i = 0; i < files.length; i++) {
          const file = files[i];

          if (file.type.indexOf('image') !== -1) {
            // 使用临时 URL 显示图片预览
            const imageUrlTemp = URL.createObjectURL(file);
            const imgElement = document.createElement('img');
            imgElement.src = imageUrlTemp;
            imgElement.style.maxWidth = '200px'
            imgElement.style.maxHeight = '200px'
            divOrigin.appendChild(imgElement);

            // 上传图片并获取图片 URL
            const imageUrl = await this.uploadImage(file);
            imgElement.src = imageUrl; // 替换为服务器返回的 URL
          }
        }
      }
    },

    // 处理 dragover 事件，允许拖拽操作
    handleDragOver(e) {
      e.preventDefault(); // 允许拖拽操作
    },

    //撤回消息回执
    onMessageRecalled(messages) {
      if(messages.success === false){
        this.$message.error(messages.message);
        return;
      }
      const indexToRemove = this.historyList.findIndex(item => item.messageId == messages.messageId)
      if (indexToRemove !== -1) {
        this.historyList.splice(indexToRemove, 1);
      }
      //不是自己不发送服务端消息
      if(messages.from!='kefu_'+this.$net.userInfo.user_id) {
        this.$message.warning("用户撤回了一条消息");
        return;
      }
      //监听撤回消息 撤回消息成功调用后端接口删除数据库
      let res3 = recallMessageFn({
        messageId: messages.messageId
      })
    },

    async changeKefuFn(row, remark) {
      let nowKefuId = this.$net.userInfo.user_id
      let nowKefuName = this.$net.userInfo.nickname
      let res = await transferKefu({
        thread_id:this.thread_id,
        type:this.chatType,//私聊群聊
        kefu_id:nowKefuId,
        transfer_id:row.id,
        kefu_name:nowKefuName, //当前客服姓名
        transfer_name:row.data.nickname, //转接客服姓名
        remark:remark
      })
      if(res.code == 1){
        this.$message({type: 'success',message: '转接客服成功'});
        this.$net.socket.emit('transfer',res);
        Event.$emit('refreshKefu')
      }
    },

    sendMsg_mobile(){
      if (this.toId) {
        this.$confirm('是否确认发送消息?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          request.post("/tenantapi/kefu.kefu/sendMsgTip",{user_id:this.toId,scene:"MSGTIP"}).then((res)=>{
            this.$message({
              type: 'success',
              message: '消息发送成功!'
            });
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消发送'
          });
        });
      }
    },
    textToHtml(content){
      return content.replace(/@(\S+)/g, `<span style="color:#ffc46e"> @$1 </span>`).replace(/\n/g, '<br>')
          .replaceAll(/<color=([^>]+)>(.*?)<\/color>/g, '<span style="color: $1">$2</span>');
    },
    //客服同意买家砍价后刷新页面
    async bargRefresh() {
      this.changeSession(this.toId);
    },
    async banChat(){
      if(this.ban){
        const res = await debanGroup({group_id:this.toId});
        this.$message(res.msg);
      }else{
        const res = await banGroup({group_id:this.toId});
        this.$message(res.msg);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
:deep(.el-upload-list) {
  display: none;
}

.users{
  display: flex;
  flex-direction: column;
  gap:5px;
  .userinfo{
    cursor: pointer;
    padding: 2px;
    color:#409EFF;
    display: flex;
    gap:5px;
  }
  .el-avatar{
    width: 20px;
    height: 20px;
    border-radius: 50%;
    img{
      width: 100%;
    }
  }
  .userinfo.selected{
    background: rgb(160, 198, 232);
  }
  .userinfo:before{
    content: '@';
  }
  .userinfo:hover{
    background: rgb(160, 198, 232);
  }
}

.window__main {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  /* 历史消息容器 */
  .history-contain {
    background-image: url("~@/assets/images/bg_chat.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;

    flex: 1;
    padding: 0 20px;
    width: 100%;

    .historyMenu {

    }

    .history-status {
      padding: 10px;
      font-size: 12px;
      text-align: center;

      &--load {
        color: $--color-primary;
      }

      &--more {
        color: $--color-primary;
        cursor: pointer;
      }

      &--empty {
        color: $--color-text-regular;
      }
    }

    .message-contain {
      padding: 10px 0;
    }

    .message--my {
      display: flex;
      justify-content: flex-end;
    }

    .message--his {
      display: flex;
      justify-content: flex-start;
    }
  }

  /* 编辑器容器 */
  .editor-contain {
    display: flex;
    flex-direction: column;
    height: 180px;
    padding: 0 10px 0 10px;
    border-top: 1px solid $--border-color-base;

    // 小部件
    .editor__widget {
      user-select: none;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 40px;
      gap: 12px;
      .editor__my{
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 40px;
        gap: 12px;

      }

      .widget-item,.iconfont {
        font-size: 20px;
        color: $--color-text-secondary;
        cursor: pointer;
      }
      .ban{
        color: red;
      }
    }

    // 编辑框
    .editor__textarea {
      flex: 1;

      &::v-deep .el-textarea__inner {
        height: 100%;
        padding: 0;
        border: none;
      }
    }

    // 行为
    .editor__action {
      display: flex;
      justify-content: flex-end;
      padding-top: 10px;
    }

    .sendDiv {
      overflow: auto;
      padding: 10px 10px 0 10px;
      outline:none;
      white-space: pre; /* 保留所有空格和换行，不自动换行 */
      width: 660px;
      overflow-x: hidden;
      text-wrap: auto;
      :deep(img){
        max-width: 200px;
        max-height: 200px;
      }
    }
  }

  //无数据
  .emptyMenu {
    margin-top: 60px;
    text-align: center;

    img {
      width: 300px;
      height: 300px
    }
  }
}
.systemInfo{
  display: block;
  width: 100%;
  text-align: center;
  color:gray;
  font-size: 12px;
}
.members{
  color:#4073fa;
}
.disabled{
  background: #ccc;
  user-select: none;
  -webkit-user-select: none;
  padding: 0 !important;
  content: "交易结束,全员禁言";
}
.disabled::after {
  content: "交易结束,全员禁言";
  color: #8b8b8b;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.right-fn{
  text-align: right;
  display: flex;
  gap: 10px;
}
.tuijian_btns{
  margin-top:10px;
  text-align: right;
  display: flex;
  justify-content: flex-end;
}
.msg_tip_btns{
  display: flex;
  gap:10px;
  text-align: center;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.scrolling-container {
  margin: 10px  auto 3px auto ;
  padding: 5px;
  width:660px;
  overflow: hidden;
  white-space: nowrap;
  display: flex;
  align-items: center;
  background: #fff8df;
  border-radius: 3px;
  border: 1px solid red;
}
.scrolling-text {
  display: inline-block;
  animation: scroll 20s linear infinite;
}

@keyframes scroll {
  0% { transform: translateX(0%); }
  100% { transform: translateX(-100%); }
}

</style>
